// extracted by css-extract-rspack-plugin
export default {"option":"option-CiR6x","selectedIcon":"selectedIcon-1xPa8","isHighlighted":"isHighlighted-3L6A0"};